import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface SedeCarouselProps {
  images: string[];
  alt: string;
}
export function SedeCarousel({
  images,
  alt
}: SedeCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const hasMultiple = images.length > 1;
  const goToPrevious = () => {
    setCurrentIndex(prev => prev === 0 ? images.length - 1 : prev - 1);
  };
  const goToNext = () => {
    setCurrentIndex(prev => prev === images.length - 1 ? 0 : prev + 1);
  };
  return <div className="aspect-[16/9] overflow-hidden relative bg-gray-100" data-id="element-205">
      {/* Image track */}
      <div className="flex h-full transition-transform duration-500 ease-out" style={{
      transform: `translateX(-${currentIndex * 100}%)`
    }} data-id="element-206">
        {images.map((image, index) => <img key={index} src={image} alt={`${alt} - foto ${index + 1}`} className="w-full h-full object-cover flex-shrink-0" data-id="element-207" />)}
      </div>

      {/* Controls — only show if more than one image */}
      {hasMultiple && <>
          <button onClick={goToPrevious} aria-label="Foto anterior" className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 hover:bg-white shadow-md flex items-center justify-center text-azul transition-colors" data-id="element-208">
            <ChevronLeft className="w-5 h-5" data-id="element-209" />
          </button>
          <button onClick={goToNext} aria-label="Foto siguiente" className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 hover:bg-white shadow-md flex items-center justify-center text-azul transition-colors" data-id="element-210">
            <ChevronRight className="w-5 h-5" data-id="element-211" />
          </button>

          {/* Dots */}
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-212">
            {images.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} aria-label={`Ir a foto ${index + 1}`} className={`h-2 rounded-full transition-all ${currentIndex === index ? 'w-6 bg-white' : 'w-2 bg-white/60 hover:bg-white/80'}`} data-id="element-213" />)}
          </div>

          {/* Counter */}
          <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-black/40 text-white text-xs font-medium backdrop-blur-sm" data-id="element-214">
            {currentIndex + 1} / {images.length}
          </div>
        </>}
    </div>;
}